import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// Guard de UI, no de seguridad: user_code vive en localStorage y se puede editar.
// Quien decide es la API, que exige el grupo superadmin en cada llamada.
export const superAdminGuard: CanActivateFn = () => {
  const router = inject(Router);

  const userCodi = localStorage.getItem('user_code');
  const userJson = userCodi ? JSON.parse(atob(userCodi)) : null;

  if (userJson?.is_superadmin === true) {
    return true;
  }
  return router.createUrlTree(['/admin/dashboard']);
};
